var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C2 2.89543 2.89543 2 4 2H8C9.10457 2 10 2.89543 10 4V12.5H8C6.067 12.5 4.5 14.067 4.5 16V18H4C2.89543 18 2 17.1046 2 16V4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16C22 14.8954 21.1046 14 20 14H8C6.89543 14 6 14.8954 6 16V20C6 21.1046 6.89543 22 8 22H20C21.1046 22 22 21.1046 22 20V16Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 4C12.25 3.58579 12.5858 3.25 13 3.25C16.1756 3.25 18.75 5.82436 18.75 9V9.18934L20.4697 7.46967C20.7626 7.17678 21.2374 7.17678 21.5303 7.46967C21.8232 7.76256 21.8232 8.23744 21.5303 8.53033L18.5303 11.5303C18.4584 11.6022 18.3755 11.6565 18.2871 11.6931C18.2099 11.7251 18.1262 11.7446 18.0386 11.749C18.0258 11.7497 18.0129 11.75 18 11.75C17.8983 11.75 17.8013 11.7298 17.7129 11.6931C17.6245 11.6565 17.5416 11.6022 17.4697 11.5303L14.4697 8.53033C14.1768 8.23744 14.1768 7.76256 14.4697 7.46967C14.7626 7.17678 15.2374 7.17678 15.5303 7.46967L17.25 9.18934V9C17.25 6.65279 15.3472 4.75 13 4.75C12.5858 4.75 12.25 4.41421 12.25 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.7dcb8e0bf70d8d2fd09da16ea550be7c.svg";
export { ForwardRef as ReactComponent };